var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBybitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6948_102099)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40.5925,
    rx: 40,
    ry: 39.9988,
    fill: "#F6A500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0898 47.176V31.3633H56.2697V47.176H53.0898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0444 51.8728H9.23047V36.0601H15.7718C18.9516 36.0601 20.8004 37.7908 20.8004 40.5027C20.8004 42.2561 19.6103 43.3918 18.7881 43.7688C19.7693 44.214 21.0276 45.2134 21.0276 47.3211C21.0276 50.2738 18.9471 51.8728 16.0444 51.8728ZM15.5174 38.8129H12.4057V42.456H15.5174C16.8666 42.456 17.6206 41.7247 17.6206 40.6344C17.6206 39.5488 16.8666 38.8129 15.5174 38.8129ZM15.7218 45.2315H12.4057V49.12H15.7218C17.1618 49.12 17.8478 48.2342 17.8478 47.1667C17.8478 46.0992 17.1618 45.2361 15.7218 45.2361V45.2315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7253 45.386V51.8728H27.5682V45.386L22.6758 36.0601H26.1281L29.1671 42.4333L32.1653 36.0601H35.6176L30.7253 45.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6303 51.8728H37.8164V36.0601H44.3577C47.5375 36.0601 49.3864 37.7908 49.3864 40.5027C49.3864 42.2561 48.1962 43.3918 47.374 43.7688C48.3552 44.214 49.6135 45.2134 49.6135 47.3211C49.6135 50.2738 47.533 51.8728 44.6303 51.8728ZM44.1033 38.8129H40.9917V42.456H44.1033C45.4525 42.456 46.2066 41.7247 46.2066 40.6344C46.2066 39.5488 45.4525 38.8129 44.1033 38.8129ZM44.3078 45.2315H40.9917V49.12H44.3078C45.7478 49.12 46.4337 48.2342 46.4337 47.1667C46.4337 46.0992 45.7478 45.2361 44.3078 45.2361V45.2315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5118 38.8129V51.8728H63.3365V38.8129H59.0801V36.0601H70.7682V38.8129H66.5118Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6948_102099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0 0.59375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBybitIcon);
export default __webpack_public_path__ + "static/media/bybit-icon.1210e4c6b53da337e2be366f8f4a8834.svg";
export { ForwardRef as ReactComponent };